// Bảng màu, chữ và hằng số chuyển động cho màn mở đầu "Sân khấu cho cậu".
// Port từ dự án stage-page (Next.js + Tailwind) sang JS thuần cho photobooth.

/** `introPalette: "pink"` — tông màu gốc của template. */
const ACCENT = "#bd7d86";

export const STAGE_CREAM = "#fdf6ea";
export const STAGE_MUTED = "rgba(253, 246, 234, 0.78)";
export const STAGE_GOLD = "#f4d58a";

const VELVET = `color-mix(in srgb, ${ACCENT} 58%, #2a0d15)`;
const VELVET_DEEP = `color-mix(in srgb, ${ACCENT} 32%, #190810)`;

/** Vân nhung chia sẻ giữa mái rèm và hai tấm rèm. */
export const CURTAIN_VELVET =
    `repeating-linear-gradient(90deg, ${VELVET_DEEP} 0 16px, ${VELVET} 16px 34px, ${VELVET_DEEP} 34px 50px)`;

/** Rèm chạy: 1.35s ở bản gốc, rút còn 0.2s khi người dùng muốn giảm chuyển động. */
export const CURTAIN_EASE = "cubic-bezier(0.7, 0, 0.25, 1)";
export const CURTAIN_DURATION_MS = 1350;
export const CURTAIN_DURATION_REDUCED_MS = 200;

/** Nền tổng của cả màn sân khấu. */
export const STAGE_BACKGROUND =
    "linear-gradient(#3a1e27 0%, #2c1520 52%, #1e0e16 100%)";

/** Ảnh quầy chụp dùng trang trí trên tấm biển màn mở đầu. */
export const STAGE_ROOM_IMG = "/assets/items/room.png";

/** Chữ hiển thị trên màn mở đầu — chỉnh cho hợp bối cảnh photobooth. */
export const STAGE_COPY = {
    specialShow: "Một buổi chụp đặc biệt",
    coverTitle: "LoveGift Photobooth",
    forRecipient: receiver => `dành cho ${receiver}`,
    openCurtain: "Lưu giữ kỷ niệm ✨",
    curtainHint: "chạm để bước vào buổi chụp",
    starTonight: "ngôi sao hôm nay",
    coverSubtitle:
        "Sẵn sàng chưa nào? Đứng vào giữa khung, cười thật tươi — sân khấu này là của cậu.",
    startStory: "Bắt đầu chụp ảnh",
    receiverFallback: "Bạn"
};

/**
 * Pseudo-random tất định của bản gốc: `frac(43758.5453 * sin((i + 1) * 12.9898 * k))`.
 * Giữ vị trí hạt bụi ổn định giữa các lần render.
 */
export function stageRandom(index, seed) {
    const value = 43758.5453 * Math.sin((index + 1) * 12.9898 * seed);
    return value - Math.floor(value);
}
